import { useRef, useMemo } from 'react';

// src/utility/use-latest.ts
var useLatest = (value) => {
  const ref = useRef(value);
  ref.current = value;
  return ref;
};
var use_latest_default = useLatest;

// src/utils/index.ts
var isObject = (val) => val !== null && typeof val === "object";
var isFunction = (val) => typeof val === "function";
var isString = (val) => typeof val === "string";
var isBoolean = (val) => typeof val === "boolean";
var isNumber = (val) => typeof val === "number" && !Number.isNaN(val);
var isUndef = (val) => val === void 0;
var isThenable = (val) => (typeof val === "object" || typeof val === "function") && val !== null && "then" in val && isFunction(val.then);

// src/utils/is-dev.ts
var isDev = process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test";
var is_dev_default = isDev;

// src/utility/use-memoized-fn.ts
var useMemoizedFn = (fn) => {
  if (is_dev_default && !isFunction(fn)) {
    console.error(
      `useMemoizedFn expected parameter is a function, got ${typeof fn}`
    );
  }
  const fnRef = useRef(fn);
  fnRef.current = useMemo(() => fn, [fn]);
  const memoizedFn = useRef(void 0);
  if (!memoizedFn.current) {
    memoizedFn.current = function current(...args) {
      return fnRef.current.apply(this, args);
    };
  }
  return memoizedFn.current;
};
var use_memoized_fn_default = useMemoizedFn;

export { isBoolean, isFunction, isNumber, isObject, isString, isThenable, isUndef, is_dev_default, use_latest_default, use_memoized_fn_default };
